import React from 'react';

export const COPY_CLIPBOARD = (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    className="clipboard-copy w-6 h-6 hover:text-black cursor-pointer"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
    />
  </svg>
);

export const INVITATION_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 437.662 437.662"
    className="h-4 w-4"
    stroke="currentColor"
  >
    <g>
      <path
        d="m424.673 155.963-53.8-44.9v-63.7c0-5.5-4.8-9.7-10.4-9.7h-78.3l-31.4-26.2c-18.5-15.3-45.3-15.3-63.8.1l-31.4 26.1h-79.3c-5.5 0-10.4 4.1-10.4 9.7v64.7l-52.8 43.9c-2.2 1.9-3.5 4.8-3.4 7.7h.2v223.9c0 27.6 22.2 50.1 49.7 50.1h318.5c27.6 0 49.7-22.6 49.7-50.1v-223.9h.2c.2-3-1-5.8-3.3-7.7zm-53.8-18.9 31.5 26.2-31.5 23.4v-49.6zm-171.1-110.2c11.1-9.2 27.2-9.1 38.3.1l12.7 10.7h-63.9l12.9-10.8zm-113.9 30.8h265v143.9l-113.9 84.8c-10.8 7.9-25.4 7.9-36.1 0l-115-85.6v-143.1zm-20 80.3v47.9l-30.5-22.7 30.5-25.2zm342 249.5c.1 16.6-13.2 30.1-29.7 30.2h-318.6c-16.5-.1-29.8-13.6-29.7-30.1v-204l159.2 118.9c17.7 13.1 41.9 13.1 59.6 0l159.2-118.9v203.9z"
        fill="#030104"
      />
      <path
        d="M210.873 137.663h-54c-5.5 0-10 4.5-10 10s4.5 10 10 10h54c5.5 0 10-4.5 10-10s-4.5-10-10-10zM280.873 187.663h-124c-5.5 0-10 4.5-10 10s4.5 10 10 10h124c5.5 0 10-4.5 10-10s-4.5-10-10-10z"
        fill="#030104"
      />
    </g>
  </svg>
);

export const UNDELETE_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.757 24.757" className="h-4 w-4">
    <path
      d="M12.229.003h-.048c-.027-.006-.035-.002-.055-.002-3.203 0-6.319 1.27-8.622 3.503L.972.933A.431.431 0 0 0 .511.839a.43.43 0 0 0-.265.394v8.348c0 .235.191.425.423.425h8.266a.424.424 0 0 0 .212-.792L6.646 6.683c1.483-1.432 3.418-2.216 5.54-2.216 4.33.028 7.857 3.573 7.857 7.975-.033 4.326-3.58 7.847-7.98 7.847l.01 4.468h.061c6.779 0 12.333-5.518 12.377-12.376C24.511 5.606 19.007.06 12.229.003z"
      fill="#030104"
    />
  </svg>
);

export const NEW_DELETE_ICON = (color = 'text-litlingo-gray-5'): JSX.Element => (
  <svg
    width="11"
    height="12"
    className={`${color}`}
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_7133_119967" fill="white">
      <path d="M6.94451 10.111C7.12858 10.111 7.2777 9.96185 7.2777 9.77778V4.11077C7.2777 3.9267 7.12858 3.77759 6.94451 3.77759C6.76044 3.77759 6.61133 3.9267 6.61133 4.11077V9.77778C6.61133 9.96185 6.76044 10.111 6.94451 10.111Z" />
    </mask>
    <path
      d="M6.94451 10.111C7.12858 10.111 7.2777 9.96185 7.2777 9.77778V4.11077C7.2777 3.9267 7.12858 3.77759 6.94451 3.77759C6.76044 3.77759 6.61133 3.9267 6.61133 4.11077V9.77778C6.61133 9.96185 6.76044 10.111 6.94451 10.111Z"
      fill="white"
    />
    <path
      d="M6.94451 11.611C7.95701 11.611 8.7777 10.7903 8.7777 9.77778H5.7777C5.7777 9.13342 6.30016 8.61096 6.94451 8.61096V11.611ZM8.7777 9.77778V4.11077H5.7777V9.77778H8.7777ZM8.7777 4.11077C8.7777 3.09828 7.95701 2.27759 6.94451 2.27759V5.27759C6.30016 5.27759 5.7777 4.75513 5.7777 4.11077H8.7777ZM6.94451 2.27759C5.93202 2.27759 5.11133 3.09828 5.11133 4.11077H8.11133C8.11133 4.75513 7.58887 5.27759 6.94451 5.27759V2.27759ZM5.11133 4.11077V9.77778H8.11133V4.11077H5.11133ZM5.11133 9.77778C5.11133 10.7903 5.93202 11.611 6.94451 11.611V8.61096C7.58887 8.61096 8.11133 9.13342 8.11133 9.77778H5.11133Z"
      fill="white"
      mask="url(#path-1-inside-1_7133_119967)"
    />
    <mask id="path-3-inside-2_7133_119967" fill="white">
      <path d="M5.05584 10.111C5.23991 10.111 5.38903 9.96185 5.38903 9.77778V4.11077C5.38903 3.9267 5.23991 3.77759 5.05584 3.77759C4.87177 3.77759 4.72266 3.9267 4.72266 4.11077V9.77778C4.72266 9.96185 4.87165 10.111 5.05584 10.111Z" />
    </mask>
    <path
      d="M5.05584 10.111C5.23991 10.111 5.38903 9.96185 5.38903 9.77778V4.11077C5.38903 3.9267 5.23991 3.77759 5.05584 3.77759C4.87177 3.77759 4.72266 3.9267 4.72266 4.11077V9.77778C4.72266 9.96185 4.87165 10.111 5.05584 10.111Z"
      fill="white"
    />
    <path
      d="M5.05584 11.611C6.06834 11.611 6.88903 10.7903 6.88903 9.77778H3.88903C3.88903 9.13342 4.41148 8.61096 5.05584 8.61096V11.611ZM6.88903 9.77778V4.11077H3.88903V9.77778H6.88903ZM6.88903 4.11077C6.88903 3.09828 6.06834 2.27759 5.05584 2.27759V5.27759C4.41148 5.27759 3.88903 4.75513 3.88903 4.11077H6.88903ZM5.05584 2.27759C4.04334 2.27759 3.22266 3.09828 3.22266 4.11077H6.22266C6.22266 4.75513 5.7002 5.27759 5.05584 5.27759V2.27759ZM3.22266 4.11077V9.77778H6.22266V4.11077H3.22266ZM3.22266 9.77778C3.22266 10.7899 4.04286 11.611 5.05584 11.611V8.61096C5.70044 8.61096 6.22266 9.13378 6.22266 9.77778H3.22266Z"
      fill="white"
      mask="url(#path-3-inside-2_7133_119967)"
    />
    <mask id="path-5-inside-3_7133_119967" fill="white">
      <path d="M3.16619 10.111C3.35026 10.111 3.49938 9.96185 3.49938 9.77778V4.11077C3.49938 3.9267 3.35026 3.77759 3.16619 3.77759C2.98212 3.77759 2.83301 3.9267 2.83301 4.11077V9.77778C2.83301 9.96185 2.98187 10.111 3.16619 10.111Z" />
    </mask>
    <path
      d="M3.16619 10.111C3.35026 10.111 3.49938 9.96185 3.49938 9.77778V4.11077C3.49938 3.9267 3.35026 3.77759 3.16619 3.77759C2.98212 3.77759 2.83301 3.9267 2.83301 4.11077V9.77778C2.83301 9.96185 2.98187 10.111 3.16619 10.111Z"
      fill="white"
    />
    <path
      d="M3.16619 11.611C4.17869 11.611 4.99938 10.7903 4.99938 9.77778H1.99938C1.99938 9.13342 2.52184 8.61096 3.16619 8.61096V11.611ZM4.99938 9.77778V4.11077H1.99938V9.77778H4.99938ZM4.99938 4.11077C4.99938 3.09828 4.17869 2.27759 3.16619 2.27759V5.27759C2.52184 5.27759 1.99938 4.75513 1.99938 4.11077H4.99938ZM3.16619 2.27759C2.1537 2.27759 1.33301 3.09828 1.33301 4.11077H4.33301C4.33301 4.75513 3.81055 5.27759 3.16619 5.27759V2.27759ZM1.33301 4.11077V9.77778H4.33301V4.11077H1.33301ZM1.33301 9.77778C1.33301 10.7895 2.15272 11.611 3.16619 11.611V8.61096C3.81103 8.61096 4.33301 9.13415 4.33301 9.77778H1.33301Z"
      fill="white"
      mask="url(#path-5-inside-3_7133_119967)"
    />
    <mask id="path-7-inside-4_7133_119967" fill="white">
      <path d="M6.00032 0H4.11128C3.40687 0 2.83344 0.531002 2.83344 1.18313V1.88853H0.333185C0.149115 1.88853 0 2.03764 0 2.22171C0 2.40578 0.149115 2.5549 0.333185 2.5549H0.94466V10.7221C0.94466 11.4269 1.51771 12 2.22212 12H7.88913C8.59393 12 9.16707 11.4267 9.16707 10.7221V2.5549H9.77816C9.96223 2.5549 10.1113 2.40578 10.1113 2.22171C10.1113 2.03764 9.96223 1.88853 9.77816 1.88853H7.27791V1.18313C7.27803 0.531002 6.70477 0 6.00044 0H6.00032ZM3.50006 1.18313C3.50006 0.90324 3.77995 0.666371 4.11154 0.666371H6.00032C6.33188 0.666371 6.61179 0.903243 6.61179 1.18313V1.88853L3.50009 1.88865L3.50006 1.18313ZM8.5007 10.7221C8.5007 11.0592 8.22614 11.3336 7.88913 11.3336H2.22212C1.88497 11.3336 1.61103 11.0591 1.61103 10.7221V2.5549H8.50067L8.5007 10.7221Z" />
    </mask>
    <path
      d="M6.00032 0H4.11128C3.40687 0 2.83344 0.531002 2.83344 1.18313V1.88853H0.333185C0.149115 1.88853 0 2.03764 0 2.22171C0 2.40578 0.149115 2.5549 0.333185 2.5549H0.94466V10.7221C0.94466 11.4269 1.51771 12 2.22212 12H7.88913C8.59393 12 9.16707 11.4267 9.16707 10.7221V2.5549H9.77816C9.96223 2.5549 10.1113 2.40578 10.1113 2.22171C10.1113 2.03764 9.96223 1.88853 9.77816 1.88853H7.27791V1.18313C7.27803 0.531002 6.70477 0 6.00044 0H6.00032ZM3.50006 1.18313C3.50006 0.90324 3.77995 0.666371 4.11154 0.666371H6.00032C6.33188 0.666371 6.61179 0.903243 6.61179 1.18313V1.88853L3.50009 1.88865L3.50006 1.18313ZM8.5007 10.7221C8.5007 11.0592 8.22614 11.3336 7.88913 11.3336H2.22212C1.88497 11.3336 1.61103 11.0591 1.61103 10.7221V2.5549H8.50067L8.5007 10.7221Z"
      fill="white"
    />
    <path
      d="M2.83344 1.88853V3.38853H4.33344V1.88853H2.83344ZM0.94466 2.5549H2.44466V1.0549H0.94466V2.5549ZM9.16707 2.5549V1.0549H7.66707V2.5549H9.16707ZM7.27791 1.88853H5.77791V3.38853H7.27791V1.88853ZM7.27791 1.18313L5.77791 1.18284V1.18313H7.27791ZM3.50006 1.18313H2.00006V1.18319L3.50006 1.18313ZM6.61179 1.88853L6.61185 3.38853L8.11179 3.38847V1.88853H6.61179ZM3.50009 1.88865L2.00009 1.88872L2.00016 3.38871L3.50015 3.38865L3.50009 1.88865ZM8.5007 10.7221H10.0007V10.7221L8.5007 10.7221ZM1.61103 2.5549V1.0549H0.11103V2.5549H1.61103ZM8.50067 2.5549L10.0007 2.55489L10.0007 1.0549H8.50067V2.5549ZM6.00032 -1.5H4.11128V1.5H6.00032V-1.5ZM4.11128 -1.5C2.68925 -1.5 1.33344 -0.404052 1.33344 1.18313H4.33344C4.33344 1.31204 4.27416 1.40429 4.22731 1.44766C4.18222 1.48941 4.13801 1.5 4.11128 1.5V-1.5ZM1.33344 1.18313V1.88853H4.33344V1.18313H1.33344ZM2.83344 0.388526H0.333185V3.38853H2.83344V0.388526ZM0.333185 0.388526C-0.679313 0.388526 -1.5 1.20921 -1.5 2.22171H1.5C1.5 2.86607 0.977542 3.38853 0.333185 3.38853V0.388526ZM-1.5 2.22171C-1.5 3.23421 -0.679313 4.0549 0.333185 4.0549V1.0549C0.977542 1.0549 1.5 1.57735 1.5 2.22171H-1.5ZM0.333185 4.0549H0.94466V1.0549H0.333185V4.0549ZM-0.55534 2.5549V10.7221H2.44466V2.5549H-0.55534ZM-0.55534 10.7221C-0.55534 12.2548 0.688843 13.5 2.22212 13.5V10.5C2.34657 10.5 2.44466 10.5989 2.44466 10.7221H-0.55534ZM2.22212 13.5H7.88913V10.5H2.22212V13.5ZM7.88913 13.5C9.42245 13.5 10.6671 12.2551 10.6671 10.7221H7.66707C7.66707 10.5984 7.7654 10.5 7.88913 10.5V13.5ZM10.6671 10.7221V2.5549H7.66707V10.7221H10.6671ZM9.16707 4.0549H9.77816V1.0549H9.16707V4.0549ZM9.77816 4.0549C10.7907 4.0549 11.6113 3.23421 11.6113 2.22171H8.61135C8.61135 1.57735 9.13381 1.0549 9.77816 1.0549V4.0549ZM11.6113 2.22171C11.6113 1.20921 10.7907 0.388526 9.77816 0.388526V3.38853C9.13381 3.38853 8.61135 2.86607 8.61135 2.22171H11.6113ZM9.77816 0.388526H7.27791V3.38853H9.77816V0.388526ZM8.77791 1.88853V1.18313H5.77791V1.88853H8.77791ZM8.77791 1.18341C8.77821 -0.403751 7.42264 -1.5 6.00044 -1.5V1.5C5.97361 1.5 5.92926 1.48936 5.88408 1.44751C5.83713 1.40404 5.77788 1.31172 5.77791 1.18284L8.77791 1.18341ZM6.00044 -1.5H6.00032V1.5H6.00044V-1.5ZM5.00006 1.18313C5.00006 1.5638 4.81004 1.82987 4.64992 1.96525C4.48867 2.10158 4.29783 2.16637 4.11154 2.16637V-0.833629C3.19739 -0.833629 2.00006 -0.151326 2.00006 1.18313H5.00006ZM4.11154 2.16637H6.00032V-0.833629H4.11154V2.16637ZM6.00032 2.16637C5.81399 2.16637 5.62316 2.10157 5.46194 1.96526C5.30185 1.82991 5.11179 1.56384 5.11179 1.18313H8.11179C8.11179 -0.151349 6.91441 -0.833629 6.00032 -0.833629V2.16637ZM5.11179 1.18313V1.88853H8.11179V1.18313H5.11179ZM6.61173 0.388526L3.50004 0.38865L3.50015 3.38865L6.61185 3.38853L6.61173 0.388526ZM5.00009 1.88858L5.00006 1.18306L2.00006 1.18319L2.00009 1.88872L5.00009 1.88858ZM7.0007 10.7221C7.0007 10.2306 7.39793 9.83363 7.88913 9.83363V12.8336C9.05436 12.8336 10.0007 11.8879 10.0007 10.7221H7.0007ZM7.88913 9.83363H2.22212V12.8336H7.88913V9.83363ZM2.22212 9.83363C2.71514 9.83363 3.11103 10.2324 3.11103 10.7221H0.11103C0.11103 11.8858 1.05481 12.8336 2.22212 12.8336V9.83363ZM3.11103 10.7221V2.5549H0.11103V10.7221H3.11103ZM1.61103 4.0549H8.50067V1.0549H1.61103V4.0549ZM7.00067 2.5549L7.0007 10.7221L10.0007 10.7221L10.0007 2.55489L7.00067 2.5549Z"
      fill="white"
      mask="url(#path-7-inside-4_7133_119967)"
    />
  </svg>
);

export const CURSOR_CLICK = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
    />
  </svg>
);

export const TRASH_ICON = (
  <svg
    width="100%"
    className="text-gray-700  hover:text-black"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

export const EDIT_ICON = (size = 24): JSX.Element => (
  <svg
    width={size}
    height={size}
    className="mr-1.5 text-gray-700 hover:text-black"
    viewBox="0 0 20 20"
    fill="#4a5568"
  >
    <path d="M15.1898 4.81224C14.9273 4.54979 14.5713 4.40234 14.2 4.40234C13.8288 4.40234 13.4728 4.54979 13.2102 4.81224L7.90002 10.1224V12.102H9.87962L15.1898 6.79185C15.4523 6.52931 15.5997 6.17327 15.5997 5.80205C15.5997 5.43082 15.4523 5.07478 15.1898 4.81224Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.40002 7.20078C4.40002 6.82948 4.54752 6.47338 4.81007 6.21083C5.07263 5.94828 5.42872 5.80078 5.80002 5.80078H8.60002C8.78568 5.80078 8.96372 5.87453 9.095 6.00581C9.22627 6.13708 9.30002 6.31513 9.30002 6.50078C9.30002 6.68643 9.22627 6.86448 9.095 6.99576C8.96372 7.12703 8.78568 7.20078 8.60002 7.20078H5.80002V14.2008H12.8V11.4008C12.8 11.2151 12.8738 11.0371 13.005 10.9058C13.1363 10.7745 13.3144 10.7008 13.5 10.7008C13.6857 10.7008 13.8637 10.7745 13.995 10.9058C14.1263 11.0371 14.2 11.2151 14.2 11.4008V14.2008C14.2 14.5721 14.0525 14.9282 13.79 15.1907C13.5274 15.4533 13.1713 15.6008 12.8 15.6008H5.80002C5.42872 15.6008 5.07263 15.4533 4.81007 15.1907C4.54752 14.9282 4.40002 14.5721 4.40002 14.2008V7.20078Z"
    />
  </svg>
);

export const SEE_EMAIL = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="mr-1.5 h-5 w-5 text-gray-700 hover:text-black"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

export const PLAY_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
      clipRule="evenodd"
    />
  </svg>
);

export const CLOSE_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 512 512" fill="currentColor">
    <path d="M256 33C132.3 33 32 133.3 32 257s100.3 224 224 224 224-100.3 224-224S379.7 33 256 33zm108.3 299.5c1.5 1.5 2.3 3.5 2.3 5.6 0 2.1-.8 4.2-2.3 5.6l-21.6 21.7c-1.6 1.6-3.6 2.3-5.6 2.3-2 0-4.1-.8-5.6-2.3L256 289.8l-75.4 75.7c-1.5 1.6-3.6 2.3-5.6 2.3-2 0-4.1-.8-5.6-2.3l-21.6-21.7c-1.5-1.5-2.3-3.5-2.3-5.6 0-2.1.8-4.2 2.3-5.6l75.7-76-75.9-75c-3.1-3.1-3.1-8.2 0-11.3l21.6-21.7c1.5-1.5 3.5-2.3 5.6-2.3 2.1 0 4.1.8 5.6 2.3l75.7 74.7 75.7-74.7c1.5-1.5 3.5-2.3 5.6-2.3 2.1 0 4.1.8 5.6 2.3l21.6 21.7c3.1 3.1 3.1 8.2 0 11.3l-75.9 75 75.6 75.9z" />
  </svg>
);

export const CLOSE_ICON_12 = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M1.67969 1.67969L10.4157 10.4169"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4157 1.67969L1.67969 10.4169"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CLOSE_ICON_16 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M2.24023 2.24023L13.8882 13.8898"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8882 2.24023L2.24023 13.8898"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RELOAD_ICON = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-4 h-4">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    />
  </svg>
);

export const OKTA_ICON = (
  <svg
    id="logosandtypes_com"
    data-name="logosandtypes com"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 150"
    width="20"
    height="20"
  >
    <defs>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html:
            '\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    ',
        }}
      />
    </defs>
    <path className="cls-1" d="M0,0H150V150H0V0Z" />
    <path
      className="cls-2"
      d="M81.58,8.72l-2.78,34.26c-1.31-.15-2.63-.23-3.98-.23-1.69,0-3.34,.11-4.96,.38l-1.58-16.6c-.04-.53,.38-.98,.9-.98h2.82l-1.35-16.79c-.04-.53,.38-.98,.86-.98h9.2c.53,0,.94,.45,.86,.98h0v-.04Zm-23.22,1.69c-.15-.49-.68-.79-1.16-.6l-8.64,3.16c-.49,.19-.71,.75-.49,1.2l7.03,15.33-2.67,.98c-.49,.19-.71,.75-.49,1.2l7.18,15.06c2.59-1.43,5.41-2.52,8.38-3.19L58.4,10.41h-.04Zm-21.19,9.54l19.87,28.02c-2.52,1.65-4.81,3.61-6.76,5.86l-11.91-11.72c-.38-.38-.34-.98,.04-1.31l2.18-1.8-11.83-11.98c-.38-.38-.34-.98,.08-1.31l7.03-5.9c.41-.34,.98-.26,1.28,.15h.04Zm-16.68,16.23c-.41-.3-1.01-.15-1.28,.3l-4.58,7.96c-.26,.45-.08,1.01,.38,1.24l15.25,7.21-1.43,2.44c-.26,.45-.08,1.05,.41,1.24l15.18,6.95c1.09-2.82,2.55-5.45,4.36-7.81l-28.29-19.53Zm-11.23,21.64c.08-.53,.6-.83,1.09-.71l33.25,8.68c-.86,2.82-1.35,5.79-1.43,8.87l-16.64-1.35c-.53-.04-.9-.53-.79-1.05l.49-2.78-16.79-1.58c-.53-.04-.86-.53-.79-1.05l1.58-9.05h0l.04,.04Zm-1.24,22.47c-.53,.04-.86,.53-.79,1.05l1.62,9.05c.08,.53,.6,.83,1.09,.71l16.3-4.25,.49,2.78c.08,.53,.6,.83,1.09,.71l16.08-4.43c-.94-2.78-1.54-5.75-1.69-8.79l-34.22,3.16h.04Zm5.33,23.82c-.26-.45-.08-1.01,.38-1.24l31.03-14.73c1.16,2.78,2.74,5.37,4.62,7.7l-13.6,9.69c-.41,.3-1.01,.19-1.28-.26l-1.43-2.48-13.86,9.58c-.41,.3-1.01,.15-1.28-.3l-4.62-7.96h.04Zm37.6-6.46l-24.16,24.46c-.38,.38-.34,.98,.08,1.31l7.06,5.9c.41,.34,.98,.26,1.28-.15l9.77-13.75,2.18,1.84c.41,.34,1.01,.26,1.31-.19l9.47-13.75c-2.55-1.58-4.92-3.49-6.95-5.67h-.04Zm-4.77,39.26c-.49-.19-.71-.75-.49-1.2l14.31-31.26c2.63,1.35,5.48,2.37,8.45,2.93l-4.21,16.15c-.11,.49-.68,.79-1.16,.6l-2.67-.98-4.47,16.27c-.15,.49-.68,.79-1.16,.6l-8.64-3.16h0l.04,.04Zm24.64-29.11l-2.78,34.26c-.04,.53,.38,.98,.86,.98h9.2c.53,0,.94-.45,.86-.98l-1.35-16.79h2.82c.53,0,.94-.45,.9-.98l-1.58-16.6c-1.62,.26-3.27,.38-4.96,.38-1.35,0-2.67-.08-3.98-.26h0ZM103.97,15.03c.23-.49,0-1.01-.49-1.2l-8.64-3.16c-.49-.19-1.01,.11-1.16,.6l-4.47,16.27-2.67-.98c-.49-.19-1.01,.11-1.16,.6l-4.21,16.15c3.01,.6,5.82,1.62,8.45,2.93l14.35-31.22h0Zm18.86,13.64l-24.16,24.46c-2.03-2.18-4.36-4.09-6.95-5.67l9.47-13.75c.3-.41,.9-.53,1.31-.19l2.18,1.84,9.77-13.75c.3-.41,.9-.49,1.28-.15l7.06,5.9c.41,.34,.41,.94,.08,1.31h-.04Zm13.07,19.23c.49-.23,.64-.79,.38-1.24l-4.62-7.96c-.26-.45-.86-.56-1.28-.3l-13.86,9.58-1.43-2.44c-.26-.45-.86-.6-1.28-.26l-13.6,9.69c1.88,2.33,3.42,4.92,4.62,7.7l31.03-14.73,.04-.04Zm4.88,12.47l1.58,9.05c.08,.53-.26,.98-.79,1.05l-34.22,3.19c-.15-3.08-.75-6.01-1.69-8.79l16.08-4.43c.49-.15,1.01,.19,1.09,.71l.49,2.78,16.3-4.25c.49-.11,1.01,.19,1.09,.71h0l.08-.04Zm-1.54,33.25c.49,.11,1.01-.19,1.09-.71l1.58-9.05c.08-.53-.26-.98-.79-1.05l-16.79-1.58,.49-2.78c.08-.53-.26-.98-.79-1.05l-16.64-1.35c-.08,3.08-.56,6.05-1.43,8.87l33.25,8.68h0l.04,.04Zm-8.87,20.66c-.26,.45-.86,.56-1.28,.3l-28.29-19.53c1.8-2.37,3.27-5,4.36-7.81l15.18,6.95c.49,.23,.68,.79,.41,1.24l-1.43,2.44,15.25,7.21c.45,.23,.64,.79,.38,1.24l-4.58,7.96h0Zm-37.83-11.53l19.87,28.02c.3,.41,.9,.49,1.28,.15l7.03-5.9c.41-.34,.41-.94,.08-1.31l-11.83-11.98,2.18-1.8c.41-.34,.41-.94,.04-1.31l-11.91-11.72c-1.99,2.25-4.25,4.25-6.76,5.86h.04Zm-.19,38.17c-.49,.19-1.01-.11-1.16-.6l-9.09-33.13c2.97-.68,5.79-1.77,8.38-3.19l7.18,15.06c.23,.49,0,1.05-.49,1.2l-2.67,.98,7.03,15.33c.23,.49,0,1.01-.49,1.2l-8.64,3.16h-.04Z"
    />
  </svg>
);

export const GOOGLE_ICON = (
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
    <g fill="#000" fillRule="evenodd">
      <path
        d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
        fill="#EA4335"
      />
      <path
        d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
        fill="#4285F4"
      />
      <path
        d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
        fill="#FBBC05"
      />
      <path
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
        fill="#34A853"
      />
      <path fill="none" d="M0 0h18v18H0z" />
    </g>
  </svg>
);

export const OFFICE_365_ICON = (
  <svg
    enableBackground="new 0 0 2075 2499.8"
    viewBox="0 0 2075 2499.8"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
  >
    <path
      d="m0 2016.6v-1519.8l1344.4-496.8 730.6 233.7v2045.9l-730.6 220.3-1344.4-483.3 1344.4 161.8v-1769.2l-876.8 204.6v1198.3z"
      fill="#eb3c00"
    />
  </svg>
);

export const ERROR_ICON = (
  <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6004 5.9999C11.6004 7.48511 11.0104 8.9095 9.96019 9.9597C8.90999 11.0099 7.4856 11.5999 6.00039 11.5999C4.51518 11.5999 3.0908 11.0099 2.04059 9.9597C0.990389 8.9095 0.400391 7.48511 0.400391 5.9999C0.400391 4.51469 0.990389 3.09031 2.04059 2.0401C3.0908 0.989901 4.51518 0.399902 6.00039 0.399902C7.4856 0.399902 8.90999 0.989901 9.96019 2.0401C11.0104 3.09031 11.6004 4.51469 11.6004 5.9999V5.9999ZM6.70039 8.7999C6.70039 8.98555 6.62664 9.1636 6.49537 9.29488C6.36409 9.42615 6.18604 9.4999 6.00039 9.4999C5.81474 9.4999 5.63669 9.42615 5.50542 9.29488C5.37414 9.1636 5.30039 8.98555 5.30039 8.7999C5.30039 8.61425 5.37414 8.4362 5.50542 8.30493C5.63669 8.17365 5.81474 8.0999 6.00039 8.0999C6.18604 8.0999 6.36409 8.17365 6.49537 8.30493C6.62664 8.4362 6.70039 8.61425 6.70039 8.7999V8.7999ZM6.00039 2.4999C5.81474 2.4999 5.63669 2.57365 5.50542 2.70493C5.37414 2.8362 5.30039 3.01425 5.30039 3.1999V5.9999C5.30039 6.18555 5.37414 6.3636 5.50542 6.49488C5.63669 6.62615 5.81474 6.6999 6.00039 6.6999C6.18604 6.6999 6.36409 6.62615 6.49537 6.49488C6.62664 6.3636 6.70039 6.18555 6.70039 5.9999V3.1999C6.70039 3.01425 6.62664 2.8362 6.49537 2.70493C6.36409 2.57365 6.18604 2.4999 6.00039 2.4999Z"
      fill="#ED2E5C"
    />
  </svg>
);

export const SWITCH_HORIZONTAL_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
    />
  </svg>
);

export const DUPLICATE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 hover:text-black"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
    />
  </svg>
);

export const DELETE_ICON = (
  <svg
    className="mr-1.5 h-5 w-5 text-gray-700 hover:text-black"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

export const CLOSE_MODAL_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.8 2.8L17.36 17.362"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.36 2.8L2.8 17.362"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NEW_EDIT_ICON = (color = 'text-litlingo-gray-5'): JSX.Element => (
  <svg
    width="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${color}`}
  >
    <path
      d="M18.9274 5.16541L14.9619 1.19995L2.0756 14.0863L6.04106 18.0517L18.9274 5.16541Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0402 18.0524L1.2002 18.9284L2.07419 14.0864"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.084 3.07837L15.654 5.64837"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PAGINATION_PREV = (
  <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 12.8335L1.66667 7.00016L7.5 1.16683"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PAGINATION_NEXT = (
  <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 1.1665L7.33333 6.99984L1.5 12.8332"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PAGINATION_FIRST = (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.8333 12.6667L9 6.83333L14.8333 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.83333 12.6667L1 6.83333L6.83333 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PAGINATION_LAST = (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1.1665L6.83333 6.99984L1 12.8332"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 1L14.8333 6.83333L9 12.6667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const INDENTATION_ICON = (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0V6C1 8.20914 2.79086 10 5 10H11" stroke="currentColor" />
  </svg>
);

export const EXCEL_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5583 9.53719L4.65137 8.14185V18.4521C4.65137 18.9229 5.03307 19.3046 5.50392 19.3046H19.1476C19.6185 19.3046 20.0002 18.9229 20.0002 18.4521V14.6535L12.5583 9.53719Z"
      fill="#185C37"
    />
    <path
      d="M12.5583 0.700012H5.50392C5.03307 0.700012 4.65137 1.08171 4.65137 1.55257V5.35117L12.5583 10.0023L16.7444 11.3977L20.0002 10.0023V5.35117L12.5583 0.700012Z"
      fill="#21A366"
    />
    <path d="M4.65137 5.3512H12.5583V10.0024H4.65137V5.3512Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M10.3104 4.42096H4.65137V16.0489H10.3104C10.7807 16.0473 11.1615 15.6665 11.163 15.1963V5.27352C11.1615 4.8033 10.7807 4.42249 10.3104 4.42096Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.84532 4.88605H4.65137V16.514H9.84532C10.3155 16.5124 10.6963 16.1316 10.6979 15.6614V5.7386C10.6963 5.26839 10.3155 4.88758 9.84532 4.88605Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.84532 4.88605H4.65137V15.5837H9.84532C10.3155 15.5822 10.6963 15.2014 10.6979 14.7312V5.7386C10.6963 5.26839 10.3155 4.88758 9.84532 4.88605Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.38021 4.88605H4.65137V15.5837H9.38021C9.85042 15.5822 10.2312 15.2014 10.2328 14.7312V5.7386C10.2312 5.26839 9.85042 4.88758 9.38021 4.88605Z"
      fill="black"
    />
    <path
      d="M0.852556 4.88605H9.37999C9.85085 4.88605 10.2325 5.26775 10.2325 5.7386V14.266C10.2325 14.7369 9.85085 15.1186 9.37999 15.1186H0.852556C0.381701 15.1186 0 14.7369 0 14.266V5.7386C0 5.26775 0.381701 4.88605 0.852556 4.88605Z"
      fill="url(#paint0_linear_7898_45311)"
    />
    <path
      d="M2.64062 12.7735L4.43411 9.99444L2.79086 7.23071H4.11272L5.00946 8.99815C5.09226 9.16606 5.149 9.29071 5.1797 9.37303H5.19132C5.24929 9.24107 5.31134 9.11092 5.37737 8.9828L6.33597 7.23165H7.54946L5.86434 9.97909L7.59226 12.7735H6.30109L5.26528 10.8335C5.21649 10.751 5.17509 10.6643 5.14156 10.5744H5.12622C5.09587 10.6624 5.05561 10.7467 5.00621 10.8256L3.9397 12.7735H2.64062Z"
      fill="white"
    />
    <path
      d="M19.1479 0.700012H12.5586V5.35117H20.0005V1.55257C20.0005 1.08171 19.6188 0.700012 19.1479 0.700012Z"
      fill="#33C481"
    />
    <path d="M12.5586 10.0023H20.0005V14.6535H12.5586V10.0023Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_7898_45311"
        x1="1.7776"
        y1="4.21988"
        x2="8.45496"
        y2="15.7848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
);

export const EYE_ICON = (
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_10129_87262)">
      <path
        d="M22.4946 12.0263C20.7806 16.1355 16.726 19.0199 11.9996 19.0199C7.27277 19.0199 3.2165 16.1352 1.50439 12.0263C3.21475 7.91578 7.27096 5.0293 11.9996 5.0293C16.7278 5.0293 20.7823 7.91544 22.4946 12.0263Z"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 16.1798C14.2946 16.1798 16.1549 14.3195 16.1549 12.0247C16.1549 9.72992 14.2946 7.86963 11.9998 7.86963C9.70502 7.86963 7.84473 9.72992 7.84473 12.0247C7.84473 14.3195 9.70502 16.1798 11.9998 16.1798Z"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10129_87262">
        <rect width="24" height="16.8489" fill="white" transform="translate(0 3.6001)" />
      </clipPath>
    </defs>
  </svg>
);

export const EYE_SLASH_ICON = (
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2549_113)">
      <mask
        id="mask0_2549_113"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="24"
        height="18"
      >
        <path d="M24 3.6001H0V20.449H24V3.6001Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2549_113)">
        <path
          d="M22.4946 12.0263C20.7806 16.1355 16.726 19.0199 11.9996 19.0199C7.27278 19.0199 3.2165 16.1352 1.50439 12.0263C3.21475 7.91578 7.27097 5.0293 11.9996 5.0293C16.7278 5.0293 20.7823 7.91544 22.4946 12.0263Z"
          stroke="#333333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9998 16.1798C14.2946 16.1798 16.1549 14.3195 16.1549 12.0247C16.1549 9.72992 14.2946 7.86963 11.9998 7.86963C9.70502 7.86963 7.84473 9.72992 7.84473 12.0247C7.84473 14.3195 9.70502 16.1798 11.9998 16.1798Z"
          stroke="#333333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M1.29297 22.293L22.293 1.29297"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2549_113">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const THUMBS_UP_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M6.50748 1.5805C6.4328 3.54929 6.19953 4.70251 5.05451 6.405C4.85968 6.21572 4.59645 6.09647 4.3084 6.09647H1.0771C0.489703 6.09647 0 6.58618 0 7.17357V13.6362C0 14.2236 0.489703 14.7133 1.0771 14.7133H4.3084C4.61056 14.7133 4.88547 14.5825 5.08256 14.3767C5.22298 14.4879 5.35383 14.5902 5.5033 14.6796C5.82099 14.8697 6.19138 14.984 6.66455 15.033C7.61089 15.131 9.10151 15.0578 12.5662 15.0723C12.6898 15.0723 12.813 15.0277 12.9084 14.9489C13.5939 14.3897 13.9306 13.8145 14.0864 13.2042C14.1463 13.1717 14.1999 13.1276 14.2435 13.0752C14.7633 12.4255 14.973 11.6756 14.883 10.9995C14.9118 10.9761 14.9382 10.9498 14.9616 10.921C15.5644 10.1675 15.7555 9.27609 15.5394 8.52554C15.8929 8.06668 16.0456 7.52801 15.9882 7.02771C15.9177 6.41414 15.5252 5.86127 14.9335 5.6028C14.8665 5.57358 14.7935 5.55821 14.7204 5.55792H10.2998C10.5363 3.79148 10.3557 2.17197 9.73316 1.0756C9.38039 0.454442 8.84202 0.0902562 8.30264 0.00972506C7.29017 -0.0778611 6.51008 0.424606 6.50748 1.5805ZM8.07263 1.07001C8.35092 1.06749 8.6615 1.31591 8.79631 1.60856C9.28683 2.47232 9.51626 4.17135 9.16657 5.99549C9.10749 6.3052 9.37863 6.63402 9.6939 6.63502H14.5633C14.7645 6.74749 14.8901 6.91979 14.9167 7.15113C14.9416 7.36799 14.8479 7.62949 14.6306 7.89164H12.2015C11.917 7.89164 11.6574 8.14563 11.6574 8.43019C11.6574 8.71476 11.917 8.97276 12.2015 8.96874H14.5296C14.5706 9.27347 14.4953 9.65679 14.2491 10.0458H12.2015C11.917 10.0458 11.6574 10.2998 11.6574 10.5844C11.6574 10.8689 11.917 11.127 12.2015 11.1229H13.8116C13.8525 11.4277 13.7772 11.811 13.5311 12.2H12.2015C11.917 12.2 11.6574 12.454 11.6574 12.7386C11.6574 13.0231 11.917 13.2811 12.2015 13.2771H12.9308C12.8205 13.5147 12.6453 13.725 12.3361 13.9952C9.06746 13.9851 7.5095 14.038 6.77113 13.9615C6.39076 13.9221 6.24066 13.8662 6.05307 13.754C5.89691 13.6606 5.68132 13.4819 5.3855 13.2435V7.78504C7.07019 5.53281 7.49511 3.95757 7.58458 1.631C7.65821 1.22527 7.85619 1.07198 8.07263 1.07001ZM1.0771 7.17357H4.3084C4.29619 9.31319 4.3084 11.4797 4.3084 13.6362H1.0771V7.17357ZM2.69275 11.3025C2.29616 11.3025 1.97468 11.6239 1.97468 12.0205C1.97468 12.4171 2.29616 12.7386 2.69275 12.7386C3.08932 12.7386 3.41082 12.4171 3.41082 12.0205C3.41082 11.6239 3.08932 11.3025 2.69275 11.3025Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const THUMBS_DOWN_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M9.49252 14.4195C9.5672 12.4507 9.80047 11.2975 10.9455 9.595C11.1403 9.78428 11.4035 9.90353 11.6916 9.90353H14.9229C15.5103 9.90353 16 9.41382 16 8.82643V2.36384C16 1.77644 15.5103 1.28674 14.9229 1.28674H11.6916C11.3894 1.28674 11.1145 1.41752 10.9174 1.62333C10.777 1.51207 10.6462 1.40983 10.4967 1.3204C10.179 1.13033 9.80862 1.01596 9.33545 0.966954C8.38911 0.868957 6.89849 0.94223 3.43384 0.927708C3.31015 0.927708 3.18698 0.972335 3.09164 1.05112C2.40614 1.6103 2.06942 2.1855 1.91357 2.79578C1.85368 2.82834 1.80006 2.87239 1.75649 2.92483C1.23666 3.57452 1.027 4.32442 1.11696 5.00048C1.08817 5.02385 1.06181 5.05022 1.03842 5.07902C0.435569 5.83249 0.244491 6.72391 0.460593 7.47445C0.107053 7.93332 -0.0456429 8.47199 0.0118017 8.97229C0.082262 9.58586 0.474847 10.1387 1.06646 10.3972C1.13349 10.4264 1.20652 10.4418 1.27964 10.4421L5.70023 10.4421C5.46369 12.2085 5.64426 13.828 6.26684 14.9244C6.61961 15.5456 7.15798 15.9097 7.69736 15.9903C8.70983 16.0779 9.48992 15.5754 9.49252 14.4195ZM7.92737 14.93C7.64908 14.9325 7.3385 14.6841 7.20369 14.3914C6.71317 13.5277 6.48373 11.8286 6.83343 10.0045C6.89251 9.6948 6.62137 9.36598 6.3061 9.36498L1.43672 9.36498C1.23553 9.25251 1.10989 9.08021 1.0833 8.84887C1.05842 8.63201 1.15207 8.37051 1.3694 8.10836H3.79849C4.08302 8.10836 4.34264 7.85436 4.34264 7.56981C4.34264 7.28524 4.08301 7.02724 3.79849 7.03126H1.47037C1.42944 6.72653 1.50472 6.34321 1.75087 5.95416H3.79849C4.08302 5.95416 4.34264 5.70016 4.34264 5.41561C4.34264 5.13106 4.08301 4.87304 3.79849 4.87706H2.18844C2.14751 4.57233 2.22278 4.18902 2.46894 3.79997H3.79849C4.08302 3.79997 4.34264 3.54598 4.34264 3.26142C4.34264 2.97687 4.08301 2.71885 3.79849 2.72287H3.0692C3.17952 2.48534 3.35465 2.27498 3.66385 2.00481C6.93254 2.01486 8.4905 1.96199 9.22887 2.03847C9.60924 2.07785 9.75934 2.13376 9.94693 2.24601C10.1031 2.33945 10.3187 2.51814 10.6145 2.75653L10.6145 8.21496C8.92981 10.4672 8.50489 12.0424 8.41542 14.369C8.34179 14.7747 8.14381 14.928 7.92737 14.93ZM14.9229 8.82643H11.6916C11.7038 6.68681 11.6916 4.52028 11.6916 2.36384H14.9229L14.9229 8.82643ZM13.3073 4.69755C13.7038 4.69755 14.0253 4.37608 14.0253 3.97949C14.0253 3.58292 13.7038 3.26142 13.3073 3.26142C12.9107 3.26142 12.5892 3.58292 12.5892 3.97949C12.5892 4.37608 12.9107 4.69755 13.3073 4.69755Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const THUMBS_UP_FILL_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.50748 1.5805C6.4328 3.54929 6.19953 4.70251 5.05451 6.405C4.85968 6.21572 4.59645 6.09647 4.3084 6.09647H1.0771C0.489703 6.09647 0 6.58618 0 7.17357V13.6362C0 14.2236 0.489703 14.7133 1.0771 14.7133H4.3084C4.61056 14.7133 4.88547 14.5825 5.08256 14.3767C5.22298 14.4879 5.35383 14.5902 5.5033 14.6796C5.82099 14.8697 6.19138 14.984 6.66455 15.033C7.61089 15.131 9.10151 15.0578 12.5662 15.0723C12.6898 15.0723 12.813 15.0277 12.9084 14.9489C13.5939 14.3897 13.9306 13.8145 14.0864 13.2042C14.1463 13.1717 14.1999 13.1276 14.2435 13.0752C14.7633 12.4255 14.973 11.6756 14.883 10.9995C14.9118 10.9761 14.9382 10.9498 14.9616 10.921C15.5644 10.1675 15.7555 9.27609 15.5394 8.52554C15.8929 8.06668 16.0456 7.52801 15.9882 7.02771C15.9177 6.41414 15.5252 5.86127 14.9335 5.6028C14.8665 5.57358 14.7935 5.55821 14.7204 5.55792H10.2998C10.5363 3.79148 10.3557 2.17197 9.73316 1.0756C9.38039 0.454442 8.84202 0.0902562 8.30264 0.00972506C7.29017 -0.0778611 6.51008 0.424606 6.50748 1.5805ZM1.0771 7.17357H4.3084C4.29619 9.31319 4.3084 11.4797 4.3084 13.6362H1.0771V7.17357ZM2.69275 11.3025C2.29616 11.3025 1.97468 11.6239 1.97468 12.0205C1.97468 12.4171 2.29616 12.7386 2.69275 12.7386C3.08932 12.7386 3.41082 12.4171 3.41082 12.0205C3.41082 11.6239 3.08932 11.3025 2.69275 11.3025Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const THUMBS_DOWN_FILL_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.49252 14.4195C9.5672 12.4507 9.80047 11.2975 10.9455 9.595C11.1403 9.78428 11.4035 9.90353 11.6916 9.90353H14.9229C15.5103 9.90353 16 9.41382 16 8.82643V2.36384C16 1.77644 15.5103 1.28674 14.9229 1.28674H11.6916C11.3894 1.28674 11.1145 1.41752 10.9174 1.62333C10.777 1.51207 10.6462 1.40984 10.4967 1.3204C10.179 1.13033 9.80862 1.01596 9.33545 0.966955C8.38911 0.868957 6.89849 0.942231 3.43384 0.927709C3.31015 0.927709 3.18699 0.972336 3.09164 1.05113C2.40614 1.6103 2.06942 2.1855 1.91357 2.79578C1.85368 2.82835 1.80006 2.87239 1.75649 2.92483C1.23666 3.57452 1.02701 4.32442 1.11696 5.00048C1.08817 5.02385 1.06181 5.05023 1.03842 5.07902C0.435569 5.83249 0.244492 6.72391 0.460593 7.47446C0.107053 7.93332 -0.0456429 8.47199 0.0118017 8.97229C0.082262 9.58586 0.474847 10.1387 1.06646 10.3972C1.13349 10.4264 1.20652 10.4418 1.27964 10.4421L5.70023 10.4421C5.46369 12.2085 5.64426 13.828 6.26684 14.9244C6.61961 15.5456 7.15798 15.9097 7.69736 15.9903C8.70983 16.0779 9.48992 15.5754 9.49252 14.4195ZM14.9229 8.82643H11.6916C11.7038 6.68681 11.6916 4.52028 11.6916 2.36384H14.9229L14.9229 8.82643ZM13.3073 4.69755C13.7038 4.69755 14.0253 4.37608 14.0253 3.97949C14.0253 3.58292 13.7038 3.26142 13.3073 3.26142C12.9107 3.26142 12.5892 3.58292 12.5892 3.97949C12.5892 4.37608 12.9107 4.69755 13.3073 4.69755Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const EXTERNAL_LINK_WHITE_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M4.49106 0.599976H0.600098V11.4H11.2669V7.22792"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.267 4.62409V0.599976H7.19849"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.92603 5.99998L11.2668 0.599976"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default COPY_CLIPBOARD;
